import { FileArrowDown } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { ExportEntity } from 'core/enums';
import { useCliJobHandler } from 'core/hooks';
import { useAgGridTableContext } from 'core/states';
import { QuoteType } from 'quotes/enums';
import { useQuoteActions } from 'quotes/hooks';
import { Variant } from 'theme/enums';

export const ExportQuotesButton = () => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  const { handleCliJobExport } = useCliJobHandler();
  const { exportQuote } = useQuoteActions();

  const onExportQuotesClick = () => {
    const exportData = {
      exportType: ExportEntity.QUOTE_LIST,
      options: {
        quoteType: QuoteType.CUSTOMER,
        sortField: ['updated_at'],
        sortDirection: ['desc'],
        filters: {
          id: selectedRows.map((row) => row.id),
        },
      },
    };

    const exportOptions = {
      exportInProgressMessage: t('messageGenerateExportFileInProgress'),
      exportSuccessMessage: t('messageGenerateExportFileSuccess'),
    };

    handleCliJobExport(exportQuote, exportData, exportOptions);
  };

  return (
    <Button
      text={t('buttonLabelExportQuotes')}
      onClick={onExportQuotesClick}
      variant={Variant.OUTLINED}
      startDecorator={<FileArrowDown />}
    />
  );
};
